import { render } from "./ArrowIcon.vue?vue&type=template&id=b8755308&scoped=true"
const script = {}

import "./ArrowIcon.vue?vue&type=style&index=0&id=b8755308&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8755308"]])

export default __exports__